import React from 'react';
import { useState } from 'react';
import { connect } from 'react-redux';
import DisputeImages from '../../../../order/order-return/raise-return-claim/disputeImagesFlow/DisputeImages';

const PackagingLabel = props => {
    const {
        proofImages,
        labelFront,
        setFrontImage,
        errors,
        updateError,
        setProofImagesList
    } = props;

    const [isUploading,updateUploading] = useState({
        front: false,
        proof: false
    });
    let isError = errors.labelProof || errors.frontErr || errors.labelErr;
    return (
        <div className={'marginB15'}>
            {/* {Number(props.lbl_img_mandatory) == 1 ? 
            <div className={"rejected-product-container audit-pending"}>
                <div className={"pending-text warning-status"}>
                    <i className="icon-Info"></i>
                    <div>
                    <div className={"pending-status"}>
                        Product Packaging Label Required
                    </div>
                    <div className={"rejection-message"}>
                        {`This category requires the Product packaging label image to be uploaded.This is usually on the backside of the product and needs to show details such as ingredients, net weight /
                        volume, marketed by, manufacturing license, customer care contact details, etc.

                        Failure to upload this image will lead to product being rejected during audit.
                        `}
                    </div>
                    </div>
                </div> 
            </div> : null} */}
            <label className={'proof-label'}>{'Attached Photo Proof of Product Packaging Label'}</label>
            <div className={`proof-holder ${labelFront[0]?.url?'front':''} ${proofImages[0]?.url?'back':''} ${isError?'err':''}`}>

                <DisputeImages
                    list={labelFront}
                    maxFiles={1}
                    maxSize={50}
                    hasError={isError}
                    isPurchaseImage={false}
                    updateList={list => {
                        setFrontImage(list);
                        let errObj = {...errors};
                        errObj.frontErr = '';
                        errObj.labelProof = '';
                        errObj.labelErr = '';
                        updateError({...errObj});
                    }}
                    updateError={(error,errMsg) => {
                        let errObj = {...errors};
                        errObj.frontErr = errMsg;
                        updateError({...errObj});
                    }}
                    noImages={isError ? true : false}
                    uploading={isUploading.front}
                    updateUploading={(status) => updateUploading({
                        front: status,
                        proof: isUploading.proof
                    })}
                    updateUp
                    validTypes = {['jpg', 'jpeg', 'png', 'webp']}
                    fileType={'image/*'}
                    customBtn={{
                        btnTxt: "Upload Photo of Front View of Product"
                    }}
                    swipeableDrawer={() => {
                        
                    }}
                    imagesErrMsg={isError}
                    ignoreMobilOption={true}
                    ignoreMobCss={props.deviceData.isMobile}
                />
                <DisputeImages
                    list={proofImages}
                    maxFiles={1}
                    maxSize={50}
                    hasError={errors.labelProof || errors.labelErr ? true : false}
                    isPurchaseImage={false}
                    updateList={list => {
                        setProofImagesList(list);
                        let errObj = {...errors};
                        errObj.frontErr = '';
                        errObj.labelProof = '';
                        errObj.labelErr = '';
                        updateError({...errObj});
                    }}
                    updateError={(error,errMsg) => {
                        let errObj = {...errors};
                        errObj.labelProof = errMsg;
                        updateError({...errObj});
                    }}
                    noImages={errors.labelProof || errors.labelErr}
                    uploading={isUploading.proof}
                    updateUploading={(status) => updateUploading({
                        front: isUploading.front,
                        proof: status
                    })}
                    updateUp
                    validTypes = {['jpg', 'jpeg', 'png', 'webp']}
                    fileType={'image/*'}
                    customBtn={{
                        btnTxt: "Upload Photo of Product Packaging Label"
                    }}
                    swipeableDrawer={() => {

                    }}
                    imagesErrMsg={errors['labelProof'] || errors['labelErr']?true:false}
                    ignoreMobilOption={true}
                    ignoreMobCss={props.deviceData.isMobile}
                />
            </div>
        </div>
    )
};

const mapStateToProps = (state,props) => {
    return {
        deviceData: state.library.deviceData,
        lbl_img_mandatory: state.productSpecification.lbl_img_mandatory
    }
}

export default connect(mapStateToProps)(PackagingLabel);